module.exports = __webpack_public_path__ + "img/patient.203d267c.svg";